/**
 * This class handles most of the basic animation for the site.
 * 
 * @export
 * @class Global
 */
import { Parallax } from '../../helpers/parallax';

export class Animations {

    constructor() {
        new Parallax('.o-fade-in', 'o-fade-in--is-visible', 0.10);
        new Parallax('.o-slide-in', 'o-slide-in--is-visible', 0.75);
    }
}
